function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.17765 1C6.97849 1 6.77933 1.04737 6.58784 1.11842L0.950155 3.52632C0.168846 3.85789 -0.206489 4.78158 0.115227 5.57895L3.91453 15.0132C4.15199 15.6211 4.71116 15.9842 5.30097 16C5.50013 16 5.70695 15.9763 5.90611 15.8816L11.5514 13.4737C12.1259 13.2289 12.4783 12.6447 12.4936 12.0526C12.5013 11.8553 12.463 11.6263 12.394 11.4211L8.56409 1.98684C8.34195 1.37895 7.77512 1.00789 7.17765 1ZM9.84329 1L12.486 7.59211V2.57895C12.486 2.16018 12.3245 1.75857 12.0372 1.46246C11.7499 1.16635 11.3603 1 10.954 1H9.84329ZM14.0256 2.21579V9.34474L15.8869 4.71842C16.201 3.91316 15.841 2.99737 15.052 2.66579L14.0256 2.21579ZM7.17765 2.55526L10.9923 12.0447L5.33161 14.4605L1.51699 4.97895",
  fill: "currentColor"
});

function SvgAlias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlias);
export default __webpack_public_path__ + "static/media/alias.4f0af04d.svg";
export { ForwardRef as ReactComponent };